module.exports = __webpack_public_path__ + "img/DW365-197.31fba3fb.jpg";